import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';

import { BaseController } from '../../../core/abstractions/base.controller';
import { ReportModel } from '../../../models/report.model';
import { ReportsResource } from '../../../services/resources/reports.resource';

@Component({
    selector: 'sl-reports-form',
    templateUrl: './reports-form.component.html',
    styleUrls: ['./reports-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportsFormComponent extends BaseController<ReportModel> implements OnInit {
    protected override readonly _entityResource = inject(ReportsResource);

    private readonly formBuilder = inject(FormBuilder);

    override ngOnInit(): void {
        super.ngOnInit();
        this.setupForm();
    }

    reportFileSelected(event: any): void {
        const reader = new FileReader();

        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];

            reader.readAsDataURL(file);
            reader.onload = () => {
                this.formGroup.controls['fileName'].setValue(file.name);
                this.formGroup.controls['reportFile'].setValue(reader.result?.toString()?.split(',')?.at(1));
            };
            this.formGroup.controls['reportFile'].markAsDirty();
        }
    }

    private setupForm(): void {
        const controlValue = this.isView ? { value: '', disabled: true } : undefined;
        this.formGroup = this.formBuilder.group({
            description: new FormControl(controlValue, undefined),
            group: new FormControl(controlValue, undefined),
            reportFile: new FormControl(undefined, undefined),
            fileName: new FormControl(undefined, undefined)
        });
    }
}
